/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum StorageFolder {
    User = 0,
    Public = 1,
    Assets = 2,
    Diagnoses = 3,
}